import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { maxWatchedPercentage } from '../../../providers/VideoHistoryProvider/reducer';
import { ClientOnly } from '../../ClientOnly/ClientOnly';
import { imageBorderRadius } from '../../Image/PlayImage';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoProgress = ({
  className,
  percentage
}) => {
  const displayPercentage = percentage >= maxWatchedPercentage ? 100 : percentage;
  return /*#__PURE__*/_jsx(ClientOnly, {
    children: /*#__PURE__*/_jsx(Background, {
      className: className,
      children: /*#__PURE__*/_jsx(Progress, {
        style: {
          width: `${displayPercentage}%`
        }
      })
    })
  });
};
const Background = styled.div.withConfig({
  displayName: "VideoProgress__Background",
  componentId: "sc-ipbdu-0"
})(["position:relative;height:5px;width:100%;background-color:", ";opacity:0.8;border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;overflow:hidden;"], Colors.GREY_6a6a6a, imageBorderRadius, imageBorderRadius);
const Progress = styled.div.withConfig({
  displayName: "VideoProgress__Progress",
  componentId: "sc-ipbdu-1"
})(["position:absolute;top:0;bottom:0;left:0;background-color:", ";"], Colors.RED_d50000);
export const ProgressContainer = styled.div.withConfig({
  displayName: "VideoProgress__ProgressContainer",
  componentId: "sc-ipbdu-2"
})(["position:absolute;bottom:0;left:0;right:0;"]);